(function () {
  var MOBILE_MQ = '(max-width: 767px)';
  var UNSTICK_GAP = 24;

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function buildFixedPanel(startEl) {
    if (!startEl) return null;
    var existing = startEl.closest('.product-info-fixed-panel');
    if (existing) return existing;

    var nodes = [];
    var node = startEl;

    while (node) {
      nodes.push(node);
      if (node.hasAttribute('data-product-fixed-last')) break;
      node = node.nextElementSibling;
    }

    if (!nodes.length) return null;

    var panel = document.createElement('div');
    panel.className = 'product-info-fixed-panel';
    panel.setAttribute('data-product-fixed-panel', '');
    startEl.parentNode.insertBefore(panel, startEl);
    nodes.forEach(function (el) {
      panel.appendChild(el);
    });
    layoutPanelFlex(panel);
    return panel;
  }

  function layoutPanelFlex(panel) {
    if (!panel || panel.dataset.flexReady === 'true') return;
    panel.dataset.flexReady = 'true';

    var titleSticky = panel.querySelector('[data-product-title-sticky]');
    var thumb = panel.querySelector('[data-product-title-thumb]');
    var titleItem = titleSticky && titleSticky.closest('.productView-moreItem');
    var priceEl = panel.querySelector('.productView-price');
    var priceItem = priceEl && priceEl.closest('.productView-moreItem');
    var meta = panel.querySelector('.best-seller-row--meta');

    var main = document.createElement('div');
    main.className = 'product-sticky-main';
    var copy = document.createElement('div');
    copy.className = 'product-sticky-copy';

    if (thumb) main.appendChild(thumb);
    if (titleItem) copy.appendChild(titleItem);
    if (priceItem) copy.appendChild(priceItem);
    if (meta) copy.appendChild(meta);
    main.appendChild(copy);
    panel.insertBefore(main, panel.firstChild);
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildModelRow(panel, productRoot) {
    var existing = panel.querySelector('[data-product-sticky-model]');
    if (existing) return existing;

    var row = document.createElement('div');
    row.className = 'product-sticky-model';
    row.setAttribute('data-product-sticky-model', '');
    panel.appendChild(row);

    function syncModelRow() {
      var root = productRoot || document;
      var parts = [];
      var seen = {};
      var fields = root.querySelectorAll(
        '.halo-productView-right [data-product-attribute], .productView-details [data-product-attribute]'
      );
      if (!fields.length) {
        fields = root.querySelectorAll('[data-product-attribute]');
      }

      fields.forEach(function (field) {
        if (field.classList.contains('mobile')) return;
        if (field.closest('sticky-add-to-cart') || field.closest('[data-sticky-add-to-cart]')) return;
        if (field.closest('noscript')) return;

        var label = field.querySelector('.form__label');
        var valueEl = field.querySelector('[data-header-option]');
        if (!label || !valueEl) return;

        var name = '';
        label.childNodes.forEach(function (node) {
          if (node.nodeType === 3) name += node.textContent;
        });
        name = name.replace(/:/g, '').trim();
        if (!name) {
          name = (label.textContent || '')
            .replace(valueEl.textContent || '', '')
            .replace(/:/g, '')
            .trim();
        }

        var value = (valueEl.textContent || '').trim();
        if (!name || !value || seen[name]) return;
        seen[name] = true;
        parts.push({ name: name, value: value });
      });

      if (!parts.length) {
        row.innerHTML = '';
        row.classList.remove('is-ready');
        return;
      }

      row.classList.add('is-ready');
      row.innerHTML = parts
        .map(function (part) {
          return (
            '<div class="product-sticky-model__item">' +
            '<span class="product-sticky-model__label">' +
            escapeHtml(part.name) +
            ':</span> ' +
            '<span class="product-sticky-model__value">' +
            escapeHtml(part.value) +
            '</span>' +
            '</div>'
          );
        })
        .join('');
    }

    syncModelRow();

    var optionsRoot =
      (productRoot && productRoot.querySelector('.productView-options')) ||
      document.querySelector('.productView-options');
    if (optionsRoot) {
      optionsRoot.addEventListener('change', syncModelRow);
      if (window.MutationObserver) {
        var observer = new MutationObserver(syncModelRow);
        observer.observe(optionsRoot, {
          subtree: true,
          characterData: true,
          childList: true,
        });
      }
    }

    return row;
  }

  function initProductTitleSticky(root) {
    var section = root || document;
    var titleSticky = section.querySelector('[data-product-title-sticky]');
    if (!titleSticky || titleSticky.dataset.stickyReady === 'true') return;

    var startItem =
      titleSticky.closest('[data-product-fixed-include]') ||
      titleSticky.closest('.productView-moreItem');
    if (!startItem) return;

    var panel = buildFixedPanel(startItem);
    if (!panel) return;
    titleSticky.dataset.stickyReady = 'true';

    var productRoot = panel.closest('[id^="ProductSection-"]');
    var gallery =
      (productRoot && productRoot.querySelector('[data-image-gallery]')) ||
      document.querySelector('[data-image-gallery]');
    var thumbBtn = panel.querySelector('[data-product-title-thumb]');
    var thumbImg = thumbBtn && thumbBtn.querySelector('img');
    var currentIndex = 0;

    if (!gallery) return;

    buildModelRow(panel, productRoot);

    function getMainNav() {
      return gallery.querySelector('[data-image-gallery-main]') || gallery;
    }

    function getOriginalSlides() {
      var nav = getMainNav();
      var slickSlides = nav.querySelectorAll('.slick-slide:not(.slick-cloned)');
      if (slickSlides.length) {
        return Array.prototype.map.call(slickSlides, function (slide) {
          return slide.querySelector('.productView-image') || slide;
        });
      }
      return Array.prototype.slice.call(nav.querySelectorAll('.productView-image'));
    }

    function getFancyboxItems() {
      var nav = getMainNav();
      var items = nav.querySelectorAll('.slick-slide:not(.slick-cloned) [data-fancybox="images"]');
      if (items.length) return items;
      return nav.querySelectorAll('[data-fancybox="images"]');
    }

    function getCurrentIndex() {
      var nav = getMainNav();
      if (window.jQuery && jQuery(nav).hasClass('slick-initialized')) {
        try {
          return jQuery(nav).slick('slickCurrentSlide') || 0;
        } catch (e) {}
      }

      var slides = getOriginalSlides();
      if (!slides.length) return 0;

      var best = 0;
      var bestScore = -Infinity;
      slides.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        var visible = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
        if (visible > bestScore) {
          bestScore = visible;
          best = i;
        }
      });
      return best;
    }

    function syncThumb() {
      var slides = getOriginalSlides();
      currentIndex = getCurrentIndex();
      if (currentIndex < 0 || currentIndex >= slides.length) currentIndex = 0;

      var slide = slides[currentIndex];
      if (!slide) return;

      var srcImg = slide.querySelector('img[data-main-image], img');
      if (thumbImg && srcImg) {
        var src = srcImg.currentSrc || srcImg.getAttribute('src') || srcImg.getAttribute('srcset');
        if (src) thumbImg.src = src.split(' ')[0];
        if (srcImg.alt) thumbImg.alt = srcImg.alt;
      }

      if (thumbBtn) {
        thumbBtn.setAttribute('data-gallery-index', String(currentIndex));
      }
    }

    var placeholder = document.createElement('div');
    placeholder.className = 'product-info-fixed-placeholder';
    panel.parentNode.insertBefore(placeholder, panel.nextSibling);

    var isStuck = false;
    var locked = false;
    var ticking = false;

    function syncPlaceholderHeight() {
      placeholder.style.height = panel.offsetHeight + 'px';
    }

    function pin() {
      placeholder.classList.add('is-active');
      panel.classList.add('is-stuck');
      panel.style.setProperty('position', 'fixed', 'important');
      panel.style.setProperty('top', '0px', 'important');
      panel.style.setProperty('left', '0px', 'important');
      panel.style.setProperty('right', '0px', 'important');
      panel.style.setProperty('width', '100%', 'important');
      panel.style.setProperty('z-index', '90', 'important');
      syncPlaceholderHeight();
      window.requestAnimationFrame(syncPlaceholderHeight);
      isStuck = true;
    }

    function unpin() {
      panel.classList.remove('is-stuck');
      panel.removeAttribute('style');
      placeholder.classList.remove('is-active');
      placeholder.style.height = '';
      isStuck = false;
    }

    function openGallery(event) {
      event.preventDefault();
      syncThumb();
      var items = getFancyboxItems();
      if (!items.length) return;
      var index = Math.min(currentIndex, items.length - 1);
      if (window.jQuery && jQuery.fancybox) {
        jQuery.fancybox.open(jQuery(items), {}, index);
        return;
      }
      (items[index] || items[0]).click();
    }

    function onScroll() {
      if (locked) return;
      if (!isMobile()) {
        unpin();
        panel.classList.remove('is-thumb-visible');
        return;
      }

      var galleryRect = gallery.getBoundingClientRect();
      var pastGalleryHalf = galleryRect.top + galleryRect.height / 2 <= 0;
      panel.classList.toggle('is-thumb-visible', pastGalleryHalf || isStuck);
      if (pastGalleryHalf || isStuck) syncThumb();

      var titleTop = isStuck
        ? placeholder.getBoundingClientRect().top
        : panel.getBoundingClientRect().top;

      if (!isStuck) {
        if (titleTop <= 0) {
          locked = true;
          pin();
          window.requestAnimationFrame(function () {
            locked = false;
          });
        }
        return;
      }

      if (titleTop > UNSTICK_GAP) {
        locked = true;
        unpin();
        window.requestAnimationFrame(function () {
          locked = false;
        });
      }
    }

    function requestScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        onScroll();
      });
    }

    if (thumbBtn) {
      thumbBtn.addEventListener('click', openGallery);
    }

    syncThumb();

    var mainNav = getMainNav();
    if (window.jQuery && mainNav) {
      jQuery(mainNav).on('init reInit afterChange', syncThumb);
    }

    window.addEventListener('scroll', requestScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (!isMobile()) {
        unpin();
        panel.classList.remove('is-thumb-visible');
        return;
      }
      if (isStuck) {
        syncPlaceholderHeight();
      }
      onScroll();
    });
    onScroll();
  }

  function boot() {
    if (!isMobile()) return;
    document.querySelectorAll('[data-product-title-sticky]').forEach(function (el) {
      var root = el.closest('[id^="ProductSection-"]') || document;
      initProductTitleSticky(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  window.addEventListener('resize', boot);
})();
